import apiRegistration from '@/api/registration'

const state = {
  isSubmitting: false,
  state: null,
  phone: null,
  error: null,
  user: null,
  password: null,
}

export const mutationsTypes = {
  addRegisterAdminPhoneStart:
    '[register admin phone] Add register admin phone start',
  addRegisterAdminPhoneSuccess:
    '[register admin phone] Add register admin phone success',
  addRegisterAdminStateSuccess:
    '[register admin phone] Add register admin state success',
  addRegisterAdminPhoneFailure:
    '[register admin phone] Add register admin phone failure',

  getRegisterAdminSmsStart: '[register admin sms] get register admin sms start',
  getRegisterAdminSmsSuccess:
    '[register admin sms] get register admin sms success',
  getRegisterAdminSmsFailure:
    '[register admin sms] get register admin sms failure',

  addRegisterAdminSmsStart: '[register admin sms] add register admin sms start',
  addRegisterAdminSmsSuccess:
    '[register admin sms] add register admin sms success',
  addRegisterAdminSmsFailure:
    '[register admin sms] add register admin sms failure',

  registerAdminStart: '[register admin] register admin start',
  registerAdminSuccess: '[register admin] register admin success',
  registerAdminFailure: '[register admin] register admin failure',

  registerAdminChangeDataStart:
    '[register admin] register admin ChangeData start',
  registerAdminChangeDataSuccess:
    '[register admin] register admin ChangeData success',
  registerAdminChangeDataFailure:
    '[register admin] register admin ChangeData failure',

  addRegisterAdminPasswordStart:
    '[register admin] add register admin password start',
  addRegisterAdminPasswordSuccess:
    '[register admin] add register admin password success',
  addRegisterAdminPasswordFailure:
    '[register admin] add register admin password failure',

  setAdminPassword: '[register admin] set admin password',

  registerSendCodeAdminStart: '[register admin] register send code admin start',
  registerSendCodeAdminSuccess:
    '[register admin] register send code admin success',
  registerSendCodeAdminFailure:
    '[register admin] register send code admin failure',
}

export const actionsTypes = {
  registerAdminSendSmsCode: '[register admin] send sms code',
  addRegisterAdminPhone: '[register admin] Add register admin phone',
  getRegisterAdminSms: '[register admin] get register admin sms',
  addRegisterAdminSms: '[register admin] add register admin sms',
  registerAdmin: '[register admin] register admin',
  registerAdminChangeData: '[register admin] register admin ChangeData',
  addRegisterAdminPassword: '[register admin] add register admin password',
}

const mutations = {
  [mutationsTypes.addRegisterAdminPhoneStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.addRegisterAdminPhoneSuccess](state, payload) {
    state.phone = payload
    state.isSubmitting = false
  },
  [mutationsTypes.addRegisterAdminStateSuccess](state, payload) {
    state.state = payload
    state.isSubmitting = false
  },
  [mutationsTypes.addRegisterAdminPhoneFailure](state) {
    state.isSubmitting = false
  },

  [mutationsTypes.getRegisterAdminSmsStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.getRegisterAdminSmsSuccess](state) {
    state.isSubmitting = false
  },
  [mutationsTypes.getRegisterAdminSmsFailure](state, error) {
    state.isSubmitting = false
    state.error = error
  },

  [mutationsTypes.addRegisterAdminSmsStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.addRegisterAdminSmsSuccess](state) {
    state.isSubmitting = false
  },
  [mutationsTypes.addRegisterAdminSmsFailure](state, error) {
    state.isSubmitting = false
    state.error = error
  },

  [mutationsTypes.registerAdminStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.registerAdminSuccess](state, payload) {
    state.isSubmitting = false
    state.user = payload
  },
  [mutationsTypes.registerAdminFailure](state, error) {
    state.isSubmitting = false
    state.error = error
  },

  [mutationsTypes.registerAdminChangeDataStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.registerAdminChangeDataSuccess](state) {
    state.isSubmitting = false
  },
  [mutationsTypes.registerAdminChangeDataFailure](state, error) {
    state.isSubmitting = false
    state.error = error
  },

  [mutationsTypes.addRegisterAdminPasswordStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.addRegisterAdminPasswordSuccess](state) {
    state.isSubmitting = false
  },
  [mutationsTypes.addRegisterAdminPasswordFailure](state, error) {
    state.isSubmitting = false
    state.error = error
  },

  [mutationsTypes.registerSendCodeAdminStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.registerSendCodeAdminSuccess](state) {
    state.isSubmitting = false
  },
  [mutationsTypes.registerSendCodeAdminFailure](state, error) {
    state.isSubmitting = false
    state.error = error
  },

  [mutationsTypes.setAdminPassword](state, password) {
    state.password = password
  },
}

const actions = {
  [actionsTypes.addRegisterAdminPhone](context, {phone}) {
    context.commit(mutationsTypes.addRegisterAdminPhoneStart)
    return new Promise((resolve, reject) => {
      apiRegistration
        .registrationAdminPhone(phone)
        .then((response) => {
          context.commit(
            mutationsTypes.addRegisterAdminStateSuccess,
            response.state
          )
          context.commit(mutationsTypes.addRegisterAdminPhoneSuccess, phone)
          resolve(response.state)
        })
        .catch((error) => {
          context.commit(mutationsTypes.addRegisterAdminPhoneFailure)
          reject(error)
        })
    })
  },

  [actionsTypes.getRegisterAdminSms](context, data) {
    context.commit(mutationsTypes.getRegisterAdminSmsStart)
    return new Promise((resolve) => {
      apiRegistration
        .registrationCheckSmsCode(data)
        .then((response) => {
          context.commit(mutationsTypes.getRegisterAdminSmsSuccess)
          resolve(response.state)
        })
        .catch((error) => {
          context.commit(mutationsTypes.getRegisterAdminSmsFailure, error)
        })
    })
  },

  [actionsTypes.addRegisterAdminSms](context, data) {
    context.commit(mutationsTypes.addRegisterAdminSmsStart)
    return new Promise((resolve) => {
      apiRegistration
        .registrationCheckSmsCode(data)
        .then((response) => {
          context.commit(mutationsTypes.addRegisterAdminSmsSuccess)
          resolve(response)
        })
        .catch((error) => {
          context.commit(mutationsTypes.addRegisterAdminSmsFailure, error)
        })
    })
  },

  [actionsTypes.registerAdmin](context, {state}) {
    context.commit(mutationsTypes.registerAdminStart)
    return new Promise((resolve, reject) => {
      apiRegistration
        .registration(state)
        .then((response) => {
          context.commit(mutationsTypes.registerAdminSuccess, response)
          resolve(response)
        })
        .catch((error) => {
          context.commit(mutationsTypes.registerAdminFailure, error)
          reject(error)
        })
    })
  },

  [actionsTypes.registerAdminChangeData](context, data) {
    context.commit(mutationsTypes.registerAdminChangeDataStart)
    return new Promise((resolve) => {
      apiRegistration
        .registrationUserChangeData(data)
        .then((response) => {
          context.commit(
            mutationsTypes.registerAdminChangeDataSuccess,
            response
          )
          resolve(response)
        })
        .catch((error) => {
          context.commit(mutationsTypes.registerAdminChangeDataFailure, error)
        })
    })
  },

  [actionsTypes.addRegisterAdminPassword](context, data) {
    context.commit(mutationsTypes.addRegisterAdminPasswordStart)
    return new Promise((resolve) => {
      apiRegistration
        .registrationUserPassword(data)
        .then((response) => {
          context.commit(
            mutationsTypes.addRegisterAdminPasswordSuccess,
            response
          )
          resolve(response)
        })
        .catch((error) => {
          context.commit(mutationsTypes.addRegisterAdminPasswordFailure, error)
        })
    })
  },

  [actionsTypes.registerAdminSendSmsCode](context, {state}) {
    context.commit(mutationsTypes.registerSendCodeAdminStart)
    return new Promise((resolve) => {
      apiRegistration
        .registrationSendSmsCode(state)
        .then((response) => {
          context.commit(mutationsTypes.registerSendCodeAdminSuccess, response)
          resolve(response)
        })
        .catch((error) => {
          context.commit(mutationsTypes.registerSendCodeAdminFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
